import './App.css';
import Navigatio from './navigation';
import FORMAsection from './forme';

function App() {
  return (
    <div className="App">
     <Navigatio/>
     <FORMAsection/>
    </div>
  );
}

export default App;
